"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationEventType = void 0;
var ConversationEventType;
(function (ConversationEventType) {
  ConversationEventType["CHANGED_STATUS"] = "CHANGED_STATUS";
  ConversationEventType["ASSIGNED"] = "ASSIGNED";
  ConversationEventType["ADDED_CC"] = "ADDED_CC";
  ConversationEventType["REMOVED_CC"] = "REMOVED_CC";
  ConversationEventType["ADDED_BCC"] = "ADDED_BCC";
  ConversationEventType["REMOVED_BCC"] = "REMOVED_BCC";
  ConversationEventType["ADDED_TAG"] = "ADDED_TAG";
  ConversationEventType["REMOVED_TAG"] = "REMOVED_TAG";
  ConversationEventType["OPENED"] = "OPENED";
  ConversationEventType["CLICKED"] = "CLICKED";
  ConversationEventType["DISMISSED"] = "DISMISSED";
  ConversationEventType["FELL_BACK"] = "FELL_BACK";
  ConversationEventType["SUBMITTED"] = "SUBMITTED";
  ConversationEventType["ADDED_PARTICIPANTS"] = "ADDED_PARTICIPANTS";
  ConversationEventType["REMOVED_PARTICIPANTS"] = "REMOVED_PARTICIPANTS";
  ConversationEventType["GOAL_REACHED"] = "GOAL_REACHED";
  ConversationEventType["CONVERSATION_CLASSIFIED"] = "CONVERSATION_CLASSIFIED";
  ConversationEventType["LEAD_CAPTURED"] = "LEAD_CAPTURED";
  ConversationEventType["NO_PARTICIPANTS_ADDED"] = "NO_PARTICIPANTS_ADDED";
  ConversationEventType["EMAIL_EVENT"] = "EMAIL_EVENT";
  ConversationEventType["CQL_UPDATED"] = "CQL_UPDATED";
  ConversationEventType["UNENROLLED"] = "UNENROLLED";
  ConversationEventType["CONVERSATION_INFLUENCED"] = "CONVERSATION_INFLUENCED";
  ConversationEventType["MEETING_INFLUENCED"] = "MEETING_INFLUENCED";
  ConversationEventType["GOAL_MEETING_INITIATED"] = "GOAL_MEETING_INITIATED";
  ConversationEventType["FAQBOT_FEEDBACK"] = "FAQBOT_FEEDBACK";
  ConversationEventType["BOT_MATCHED_RESPONSE"] = "BOT_MATCHED_RESPONSE";
  ConversationEventType["BOT_NO_MATCHED_RESPONSE"] = "BOT_NO_MATCHED_RESPONSE";
  ConversationEventType["BOT_DEFAULT_MATCHED_RESPONSE"] = "BOT_DEFAULT_MATCHED_RESPONSE";
  ConversationEventType["CALENDAR_DROP_ERROR"] = "CALENDAR_DROP_ERROR";
  ConversationEventType["BOT_SKILL_RESPONSE"] = "BOT_SKILL_RESPONSE";
  ConversationEventType["MEETING_INITIATED"] = "MEETING_INITIATED";
  ConversationEventType["NO_CALENDAR_FOUND"] = "NO_CALENDAR_FOUND";
  ConversationEventType["END_CONVERSATION_REACHED"] = "END_CONVERSATION_REACHED";
  ConversationEventType["DEPRECATED_END_CONVERSATION_REACHED"] = "DEPRECATED_END_CONVERSATION_REACHED";
  ConversationEventType["ROUTING_FAILED"] = "ROUTING_FAILED";
  ConversationEventType["CHAT_TRANSCRIPT"] = "CHAT_TRANSCRIPT";
  ConversationEventType["END_USER_BUSINESS_EMAIL_UPDATED"] = "END_USER_BUSINESS_EMAIL_UPDATED";
  ConversationEventType["END_USER_PHONE_NUMBER_UPDATED"] = "END_USER_PHONE_NUMBER_UPDATED";
  ConversationEventType["END_USER_NAME_UPDATED"] = "END_USER_NAME_UPDATED";
  ConversationEventType["END_USER_PROPERTY_ALREADY_PRESENT"] = "END_USER_PROPERTY_ALREADY_PRESENT";
  ConversationEventType["TICKET_CREATED"] = "TICKET_CREATED";
  ConversationEventType["CAPTURE_QUESTION_ASKED"] = "CAPTURE_QUESTION_ASKED";
  ConversationEventType["CAPTURE_QUESTION_FILLED"] = "CAPTURE_QUESTION_FILLED";
  ConversationEventType["BOT_NODE_REACHED"] = "BOT_NODE_REACHED";
  ConversationEventType["FALLBACK_EMAIL_CTA_CLICK"] = "FALLBACK_EMAIL_CTA_CLICK";
  ConversationEventType["BOT_NODE_CONDITIONS_EVALUATED"] = "BOT_NODE_CONDITIONS_EVALUATED";
  ConversationEventType["SALESFORCE_SYNC_RESPONSE"] = "SALESFORCE_SYNC_RESPONSE";
  ConversationEventType["SEND_CHAT_TRANSCRIPT_SUCCESS"] = "SEND_CHAT_TRANSCRIPT_SUCCESS";
  ConversationEventType["CONVERSATION_MANUAL_PUSH"] = "CONVERSATION_MANUAL_PUSH";
  ConversationEventType["VOICE_CALL_REQUESTED"] = "VOICE_CALL_REQUESTED";
  ConversationEventType["VOICE_CALL_STARTED"] = "VOICE_CALL_STARTED";
  ConversationEventType["VOICE_CALL_BRIDGED"] = "VOICE_CALL_BRIDGED";
  ConversationEventType["VOICE_CALL_FAILED"] = "VOICE_CALL_FAILED";
  ConversationEventType["VOICE_CALL_ENDED"] = "VOICE_CALL_ENDED";
  ConversationEventType["SMS_CONVERSATION_STARTED"] = "SMS_CONVERSATION_STARTED";
  ConversationEventType["SMS_CONVERSATION_ENDED"] = "SMS_CONVERSATION_ENDED";
  // Ephemeral types
  ConversationEventType["IP_BLOCK"] = "IP_BLOCK";
  ConversationEventType["IP_UNBLOCK"] = "IP_UNBLOCK";
  ConversationEventType["CHAT_TRANSLATION_RESPONSE"] = "CHAT_TRANSLATION_RESPONSE";
})(ConversationEventType = exports.ConversationEventType || (exports.ConversationEventType = {}));